module.exports = __webpack_public_path__ + "media/news/Leipzig_Bild-5b10f75b.webp";